/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// Timers
document.addEventListener('DOMContentLoaded', () => {
    const timers = document.querySelectorAll('.js-timer'); // Pobranie wszystkich sekcji z timerami

    timers.forEach((timer) => {
        const endDateElement = timer.querySelector('.js-timer-end-date');
        const daysWrapper = timer.querySelector('.js-timer-days');
        const hoursWrapper = timer.querySelector('.js-timer-hours');
        const minutesWrapper = timer.querySelector('.js-timer-minutes');
        const secondsWrapper = timer.querySelector('.js-timer-seconds');

        if (!endDateElement || !daysWrapper || !hoursWrapper || !minutesWrapper || !secondsWrapper) {
            console.error('Nie znaleziono wymaganych elementów w sekcji timera.');
            return;
        }

        const endDate = new Date(endDateElement.value);
        if (isNaN(endDate)) {
            console.error('Nieprawidłowa data końcowa w timerze.');
            return;
        }

        // Deklaracja zmiennej przed jej użyciem
        let interval;

        const updateClock = () => {
            const now = new Date();
            const timeLeft = endDate - now;

            if (timeLeft <= 0) {
                clearInterval(interval); // Zatrzymanie tego konkretnego interwału
                timer.style.display = 'none'; // Ukrycie sekcji timera
                return;
            }

            const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

            // Aktualizacja wartości w DOM z wiodącymi zerami
            daysWrapper.textContent = days < 10 ? `0${days}` : days;
            hoursWrapper.textContent = hours < 10 ? `0${hours}` : hours;
            minutesWrapper.textContent = minutes < 10 ? `0${minutes}` : minutes;
            secondsWrapper.textContent = seconds < 10 ? `0${seconds}` : seconds;
        };

        // Uruchomienie odliczania i zapamiętanie interwału lokalnie
        updateClock(); // Pierwsze wywołanie
        interval = setInterval(updateClock, 1000); // Powtarzanie co sekundę
    });
});
/* eslint-enable no-console */
